const $ = require('js/sw-jquery/sw-jquery');
const sw = require('js/lib/sw');
const tracking = require('js/lib/tracking');
const optionDataHelper = require('js/lib/tracking/checkout-funnel-option-data-helper');

const pageStepNum = Object.freeze({
  'cart-view' : 1,
  'shipping' : 3,
  'billing' : 4,
  'confirm' : 5,
  'thank-you': 6
});


function CheckoutTracking() {
  /*
  * returns event data to be sent to GA
  * @param eventName
  * @param eventData
  */
  const getCheckoutStepData = function (steps) {
    const products = sw.data.tracking.products;

    if (!products) {
      return null;
    }

    return steps.map(function(step, index){
      //The current step in the checkout flow is the last obj in the array of steps.
      let isCurrentStep = index === (steps.length - 1);
      return {
        'ecommerce': tracking.getCheckoutStepData(products, step, isCurrentStep)
      };
    });
  };

  return {
    authMethod : '',
    trackCheckoutStepView(stepNumber) {
      const eventName = 'checkout';
      let steps = [];
      for(var i = 1; i <= stepNumber; i++){
        steps.push(i);
      }
      const data = getCheckoutStepData(steps);
      if(data) {
        data.forEach(function(checkoutStep){
          sw.track(eventName, checkoutStep, {trackingServices: ['dataLayer']});
        });
      }
    },
    trackCheckoutOptionsAndDimensions(stepNumber) {
      const eventName = 'checkoutOption';
      let optionsData;
      let dimensionsData;
      let metricsData;
      let optionAndDimensionWrapper;

      switch(stepNumber) {
        case pageStepNum['cart-view'] :
        case pageStepNum.confirm :
          optionAndDimensionWrapper = optionDataHelper.cartOptionAndDimensionWrapper();
          optionsData = optionAndDimensionWrapper.getCartOptionData(stepNumber);
          dimensionsData = optionAndDimensionWrapper.getCartDimensionData();
          metricsData = optionAndDimensionWrapper.getCartMetricData();
          break;
        case 2 :
          optionAndDimensionWrapper = optionDataHelper.loginSignupOptionAndDimensionWrapper(this.authMethod);
          optionsData = optionAndDimensionWrapper.getLoginSignupOptionData();
          dimensionsData = optionAndDimensionWrapper.getLoginSignupDimensionData();
          break;
        case pageStepNum.shipping :
          optionAndDimensionWrapper = optionDataHelper.shippingOptionAndDimensionWrapper();
          optionsData = optionAndDimensionWrapper.getShippingOptionData();
          dimensionsData = optionAndDimensionWrapper.getShippingDimensionData();
          break;
        case pageStepNum.billing :
          optionAndDimensionWrapper = optionDataHelper.billingOptionAndDimensionWrapper();
          optionsData = optionAndDimensionWrapper.getBillingOptionData();
          dimensionsData = optionAndDimensionWrapper.getBillingDimensionData();
          break;
      }
      if(optionsData){
        optionsData.forEach(function (checkoutOptionData) {
          sw.track(eventName, checkoutOptionData, {trackingServices: ['dataLayer']});
        });
      }
      if(dimensionsData){
        dimensionsData.forEach(function (checkoutDimensionData) {
          const dimObj = {
              'dimensionIndex' : checkoutDimensionData.dimension,
              'dimensionValue': checkoutDimensionData.value
          };
          sw.track('dimension', dimObj, {trackingServices: ['dataLayer']});
        });
      }
      if(metricsData){
        metricsData.forEach(function (checkoutDimensionData) {
          const metricObj = {
              'metricIndex' : checkoutDimensionData.metric,
              'metricValue' : checkoutDimensionData.value
          };
          sw.track('metric', metricObj, {trackingServices: ['dataLayer']});
        });
      }
    }
  };
}

const checkoutTracking = CheckoutTracking();
const onCheckoutFlow = pageStepNum.hasOwnProperty(sw.data.pageIdentifier);

if(onCheckoutFlow){
  checkoutTracking.trackCheckoutStepView(pageStepNum[sw.data.pageIdentifier]);
}

$(window).on('beforeunload', function(){
  if(onCheckoutFlow){
    checkoutTracking.trackCheckoutOptionsAndDimensions(pageStepNum[sw.data.pageIdentifier]);
  }
});

const trackCheckoutStepTwo = function(authMethod){
  checkoutTracking.authMethod = authMethod;
  checkoutTracking.trackCheckoutStepView(2);
  checkoutTracking.trackCheckoutOptionsAndDimensions(2);
};

sw.on('track-login-or-signup', function(eventData){
  trackCheckoutStepTwo(eventData.authMethod);
});

module.exports = {
  checkoutPageIdentifiers : Object.keys(pageStepNum)
};
